import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import Layout from '../../../brands/components/Layout'
import { InputField } from '../../../../components'
import SelectField from '../../../../components/Form/Select'
import TextAreaField from '../../../../components/Form/TextArea'
import './index.css'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppDispatch } from '../../../../redux/hook'
import { getLeavePolicyDetails } from '../../../leavepolicy/editpolicy/api'
import { LeavePolicyDetail, DateRange } from '../../pages/type'
import { validateDateRange, applyTimeOff } from '../../api'
import { HIDE_LOADER, SHOW_LOADER } from '../../../../redux/slices/LoaderSlice'
import { formatDateToLong } from '../../../resources/empresources/utils'
import { SHOW_NOTIFICATION } from '../../../../redux/slices/showNotificationSlice'
import { applyTimeoffSchema } from '../../schema'
import { getPersonalInfo } from '../../../userslisting/viewuser/api'
import { User } from '../../../userslisting/type'
import { getAllAdminUsers } from '../../../userslisting/api'
import Select from 'react-select'
import { MAX_CHAR_COUNT } from '../../../../utils/index'

const Applyrequest: React.FC = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const queryParams = new URLSearchParams(location.search)
    const othersUserId = queryParams.get('userId')
    const isGlobalOnBehalf = queryParams.get('isGlobal')

    const [isChecked, setIsChecked] = useState<boolean>(false)
    const [leaveTypeOptions, setLeaveTypeOptions] = useState<
        { value: string | number; label: string }[]
    >([])
    const [userOptions, setUserOptions] = useState<
        { value: string | number; label: string }[]
    >([])
    const [validDateRangeResults, setValidDateRangeResults] = useState<
        DateRange[]
    >([])
    const [otherUserName, setOtherUserName] = useState<string>('')
    const [othersLeavePolicyId, setOthersLeavePolicyId] = useState<string>('')
    const [invalidRequestError, setInvalidRequestError] =
        useState<boolean>(false)
    const [selectedUserId, setSelectedUserId] = useState<string>('')

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setIsChecked(e.target.checked)
    }

    const customStyles = {
        control: (provided: any) => ({
            ...provided,
            padding: '.275rem 0.45rem .275rem .25rem',
        }),
        multiValueRemove: () => ({
            display: 'none', // Hide the remove icon
        }),
        clearIndicator: () => ({
            display: 'none', // Hide the clear indicator
        }),
        indicatorSeparator: () => ({
            display: 'none', // Hide the clear indicator
        }),
        dropdownIndicator: () => ({
            color: '#62676b',
            fontSize: '3px',
            height: '18px',
            // marginRight: '4px',
        }),
        singleValue: (provided: any) => ({
            ...provided,
            fontWeight: 700,
            color: '#39877c',
        }),
    }

    useEffect(() => {
        const fetchData = async () => {
            if (othersLeavePolicyId) {
                try {
                    dispatch(SHOW_LOADER())
                    const response =
                        await getLeavePolicyDetails(othersLeavePolicyId)
                    const leavePolicyDetails =
                        response?.data?.leavePolicyDetails
                    const validLeaveTypes = leavePolicyDetails
                        .filter(
                            (policy: LeavePolicyDetail) =>
                                policy.numberOfLeaves !== 0 ||
                                policy.isUnlimited
                        )
                        .map((policy: LeavePolicyDetail) => ({
                            value: policy.leaveTypeId,
                            label: policy.leaveTypeTitle,
                        }))
                    setLeaveTypeOptions(validLeaveTypes)
                } catch (error) {
                    console.error(error)
                } finally {
                    dispatch(HIDE_LOADER())
                }
            }
        }
        fetchData()
    }, [othersLeavePolicyId])

    useEffect(() => {
        dispatch(SHOW_LOADER())
        const fetchData = async () => {
            try {
                // Call the asynchronous function and wait for its result
                const userlisting = await getAllAdminUsers({
                    advancedSearch: {
                        keyword: null,
                    },
                    isglobalSearch: false,
                    isActiveFilter: true,
                    recordsPerPage: 1000,
                })
                const validUsers = userlisting?.data?.data
                    .filter((user: User) => user.isActive === true)
                    .map((user: User) => ({
                        value: user.id,
                        label: user.name,
                    }))
                setUserOptions(validUsers)
                dispatch(HIDE_LOADER())
            } catch (err) {
                // Handle any errors here
                console.error('Error fetching holidays:', err)
            }
        }

        // Call the function to fetch data
        if (isGlobalOnBehalf) {
            fetchData()
        }
    }, [])

    const formik = useFormik({
        initialValues: {
            usersList: '',
            leaveTypes: '',
            startdate: '',
            enddate: '',
            customHours: {},
            description: '',
        },
        validationSchema: applyTimeoffSchema(validDateRangeResults),
        onSubmit: async (values) => {
            const timeOffHoursPerDate = validDateRangeResults
                .map((result, index) => ({
                    requestDate: result.date,
                    isEnabled: result.isEnabled,
                    hours: Number(
                        (formik.values.customHours as any)[
                            `customHours_${index}` as keyof typeof formik.values.customHours
                        ]
                    )
                        ? Number(
                              (formik.values.customHours as any)[
                                  `customHours_${index}` as keyof typeof formik.values.customHours
                              ]
                          )
                        : 8,
                }))
                .filter((result) => result.isEnabled)
                .map((item) => ({
                    requestDate: item.requestDate,
                    hours: item.hours,
                }))

            if (othersLeavePolicyId) {
                const requestBody = {
                    leavePolicyId: othersLeavePolicyId,
                    leaveTypeId: values.leaveTypes,
                    startDate: values.startdate,
                    endDate: values.enddate,
                    description: values.description,
                    timeOffHoursPerDate: timeOffHoursPerDate,
                    isMissingTimeOffRequest:
                        othersUserId || isGlobalOnBehalf ? true : false,
                    missingTimeOffUserId: othersUserId
                        ? othersUserId
                        : isGlobalOnBehalf
                          ? values.usersList
                          : null,
                }

                try {
                    dispatch(SHOW_LOADER())
                    const response = await applyTimeOff(requestBody)
                    if (response.status === 200) {
                        dispatch(
                            SHOW_NOTIFICATION({
                                message: 'Timeoff applied succesfully',
                                type: 'success',
                            })
                        )
                        navigate(-1)
                    }
                } catch (error) {
                    console.error(error)
                } finally {
                    dispatch(HIDE_LOADER())
                }
            } else {
                console.error('leave policy not found')
            }
        },
    })

    useEffect(() => {
        const getPersonalInformation = async () => {
            dispatch(SHOW_LOADER())

            try {
                const params = {
                    userId: othersUserId ? othersUserId : selectedUserId,
                }

                const response = await getPersonalInfo(params)
                const { firstName, lastName, leavePolicyId } =
                    response?.data || {}
                setOtherUserName(`${firstName} ${lastName}`)
                setOthersLeavePolicyId(leavePolicyId)
            } catch (err) {
                console.error('Error fetching', err)
            } finally {
                dispatch(HIDE_LOADER())
            }
        }

        getPersonalInformation()
    }, [othersUserId, selectedUserId])

    useEffect(() => {
        const handleValidateDateRange = async (
            startdate: string,
            enddate: string
        ) => {
            if (startdate && enddate) {
                const requestBody = {
                    startDate: startdate,
                    endDate: enddate,
                }
                try {
                    dispatch(SHOW_LOADER())
                    const response = await validateDateRange(requestBody)
                    setValidDateRangeResults(response.data.results)

                    const validRequestData = response?.data?.results?.filter(
                        (item: any) => item.isEnabled
                    )
                    if (validRequestData?.length === 0) {
                        setInvalidRequestError(true)
                        return
                    } else {
                        setInvalidRequestError(false)
                    }
                } catch (error) {
                    console.error('Date validation error', error)
                } finally {
                    dispatch(HIDE_LOADER())
                }
            }
        }

        handleValidateDateRange(formik.values.startdate, formik.values.enddate)
    }, [formik.values.startdate, formik.values.enddate])

    return (
        <Layout>
            <div className="">
                <div className="mb-3">
                    <h4>
                        {othersUserId && !isGlobalOnBehalf
                            ? `Request Time Off On Behalf of ${otherUserName}`
                            : isGlobalOnBehalf
                              ? `Apply Time Off On Behalf`
                              : 'Apply For Time Off'}
                    </h4>
                </div>
                <div className="timereq-form">
                    <form onSubmit={formik.handleSubmit}>
                        {isGlobalOnBehalf && (
                            <div className="row mrg-top">
                                <div className="col-sm-6 bg-green-color">
                                    <div className="form-group">
                                        <label htmlFor="usersList">Users</label>
                                        <Select
                                            id="usersList"
                                            className="mb-2 mt-2"
                                            name="usersList"
                                            options={[
                                                { value: '', label: 'Select' },
                                                ...userOptions,
                                            ]}
                                            value={
                                                userOptions.find(
                                                    (option) =>
                                                        option?.value ===
                                                        formik.values.usersList
                                                ) || {
                                                    value: '',
                                                    label: 'Select',
                                                }
                                            }
                                            onChange={(option) => {
                                                formik.setFieldValue(
                                                    'usersList',
                                                    option?.value
                                                )
                                                setSelectedUserId(
                                                    option?.value as string
                                                )
                                            }}
                                            onBlur={formik.handleBlur}
                                            styles={customStyles}
                                            isSearchable={true} // Make it typable
                                        />
                                        {formik.touched.usersList &&
                                        formik.errors.usersList ? (
                                            <div className="error">
                                                {formik.errors.usersList}
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="row mrg-top">
                            <div className="col-sm-6 bg-green-color">
                                <SelectField
                                    name="leaveTypes"
                                    label="Time Off Type"
                                    options={[
                                        {
                                            value: '',
                                            label: 'Select',
                                        },
                                        ...leaveTypeOptions,
                                    ]}
                                    value={formik.values.leaveTypes}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.leaveTypes}
                                    touched={formik.touched.leaveTypes}
                                    defaultValue="option1"
                                />
                            </div>
                        </div>

                        <div className="row mrg-top">
                            <div className="col-sm-6 bg-green-color calendar">
                                <InputField
                                    type="date"
                                    name="startdate"
                                    lable="From"
                                    value={formik.values.startdate}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.startdate}
                                    touched={formik.touched.startdate}
                                />
                            </div>
                        </div>

                        <div className="row mrg-top">
                            <div className="col-sm-6 bg-green-color calendar">
                                <InputField
                                    type="date"
                                    name="enddate"
                                    lable="To"
                                    value={formik.values.enddate}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.enddate}
                                    touched={formik.touched.enddate}
                                />
                            </div>
                        </div>

                        <div className="row mrg-top">
                            <div className="col-sm-6 emp-rad-list">
                                <ul>
                                    <li className="emp-rad">
                                        <div className="form-group-checks">
                                            <input
                                                type="checkbox"
                                                id="emp-selection"
                                                name="fav_language"
                                                value="allemp"
                                                checked={isChecked}
                                                onChange={handleCheckboxChange}
                                            />

                                            <label
                                                className="sb-checkbox__label"
                                                htmlFor="emp-selection"
                                            >
                                                Specify custom hours
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {isChecked && validDateRangeResults.length != 0 && (
                            <div className="row mrg-top">
                                <div className="col-sm-6">
                                    {validDateRangeResults.map(
                                        (result, index) => (
                                            <div
                                                key={index}
                                                className="d-flex align-items-center d-flex-forms enter-hours-input"
                                                style={{ marginTop: '7px' }}
                                            >
                                                <div className="result-date">
                                                    <span>
                                                        {formatDateToLong(
                                                            result.date
                                                        )}
                                                    </span>{' '}
                                                    <span>{result.day}</span>
                                                </div>
                                                {/* Assuming 'date' is a key in the result */}
                                                {result?.isEnabled === true ? (
                                                    <InputField
                                                        type="text"
                                                        name={`customHours.customHours_${index}`}
                                                        lable=""
                                                        placeholder="Enter hours"
                                                        value={
                                                            (formik.values
                                                                .customHours[
                                                                `customHours_${index}` as keyof typeof formik.values.customHours
                                                            ] as string) || ''
                                                        }
                                                        onChange={
                                                            formik.handleChange
                                                        }
                                                        onBlur={
                                                            formik.handleBlur
                                                        }
                                                        error={
                                                            formik.errors
                                                                .customHours?.[
                                                                `customHours_${index}` as keyof typeof formik.errors.customHours
                                                            ]
                                                                ? (formik.errors
                                                                      .customHours[
                                                                      `customHours_${index}` as keyof typeof formik.errors.customHours
                                                                  ] as string)
                                                                : undefined
                                                        }
                                                        touched={
                                                            formik.touched
                                                                .customHours?.[
                                                                `customHours_${index}` as keyof typeof formik.touched.customHours
                                                            ]
                                                                ? (formik
                                                                      .touched
                                                                      .customHours[
                                                                      `customHours_${index}` as keyof typeof formik.touched.customHours
                                                                  ] as boolean)
                                                                : undefined
                                                        }
                                                    />
                                                ) : (
                                                    <div className="non-work-day">
                                                        <span>
                                                            {'Non-work-Day'}
                                                        </span>
                                                        <span>
                                                            Reason:{' '}
                                                            {result?.reason}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        )
                                    )}
                                </div>
                            </div>
                        )}

                        <div className="row mrg-top">
                            <div className="col-sm-6">
                                <TextAreaField
                                    name="description"
                                    label="Notes"
                                    placeholder=""
                                    value={formik.values.description}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.errors.description}
                                    touched={formik.touched.description}
                                    defaultValue=""
                                    rows={6}
                                    maxLength={MAX_CHAR_COUNT}
                                />
                            </div>
                        </div>

                        {invalidRequestError && (
                            <div className="note-no-leave">
                                Note: Leaves cannot be applied because valid
                                dates are unavailable. Leaves have already been
                                applied for the following dates.
                            </div>
                        )}
                        <div className="row mt-4 mb-4">
                            <div className="col-sm-6 button-block">
                                <button
                                    type="submit"
                                    className="button button-primary me-5"
                                    disabled={invalidRequestError}
                                >
                                    SUBMIT
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        formik.resetForm()
                                        setInvalidRequestError(false)
                                    }}
                                    className="button button-outline"
                                >
                                    CANCEL
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    )
}

export default Applyrequest
